module.exports = __webpack_public_path__ + "static/img/3.f9fdf1c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/2/sp/3.png
// module id = RX9/
// module chunks = 0